/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type GetRecommendationsByTypeQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  pageType: Types.ReducedContentPageType;
  sortField?: Types.InputMaybe<Types.ContentPageSortField>;
  sortOrder?: Types.InputMaybe<Types.ContentSortOrder>;
}>;

export type GetRecommendationsByTypeQuery = {
  __typename?: 'Query';
  contentPagesNewsSourcesByType?: {
    __typename?: 'ContentPagesConnection';
    total: number;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    edges: Array<{
      __typename?: 'ContentPageEdge';
      cursor: string;
      node:
        | {
            __typename?: 'ContentInsiderModule';
            id: string;
            globalId: string;
            title: string;
            description?: string | null;
            url?: string | null;
            interactions?: {
              __typename?: 'ContentPageInteractions';
              isFollowed: boolean;
            } | null;
            entityPage?: {
              __typename?: 'EntityPage';
              slug: string;
              logoImage?: Array<{
                __typename?: 'ScaledImage';
                url?: string | null;
              }> | null;
            } | null;
          }
        | {
            __typename?: 'ContentInsiderPage';
            id: string;
            globalId: string;
            title: string;
            description?: string | null;
            url?: string | null;
            xingId?: {
              __typename?: 'XingId';
              profileImage?: Array<{
                __typename?: 'ProfileImage';
                url: string;
              } | null> | null;
            } | null;
            interactions?: {
              __typename?: 'ContentPageInteractions';
              isFollowed: boolean;
            } | null;
            entityPage?: {
              __typename?: 'EntityPage';
              slug: string;
              logoImage?: Array<{
                __typename?: 'ScaledImage';
                url?: string | null;
              }> | null;
            } | null;
          }
        | {
            __typename?: 'ContentManagedInsiderPage';
            id: string;
            globalId: string;
            title: string;
            description?: string | null;
            url?: string | null;
            interactions?: {
              __typename?: 'ContentPageInteractions';
              isFollowed: boolean;
            } | null;
            entityPage?: {
              __typename?: 'EntityPage';
              slug: string;
              logoImage?: Array<{
                __typename?: 'ScaledImage';
                url?: string | null;
              }> | null;
            } | null;
          }
        | {
            __typename?: 'ContentManagedPage';
            id: string;
            globalId: string;
            title: string;
            description?: string | null;
            url?: string | null;
            interactions?: {
              __typename?: 'ContentPageInteractions';
              isFollowed: boolean;
            } | null;
            entityPage?: {
              __typename?: 'EntityPage';
              slug: string;
              logoImage?: Array<{
                __typename?: 'ScaledImage';
                url?: string | null;
              }> | null;
            } | null;
          }
        | {
            __typename?: 'ContentPage';
            id: string;
            globalId: string;
            title: string;
            description?: string | null;
            url?: string | null;
            logoImage?: {
              __typename?: 'ContentPageLogoImage';
              square128?: string | null;
            } | null;
            interactions?: {
              __typename?: 'ContentPageInteractions';
              isFollowed: boolean;
            } | null;
            entityPage?: {
              __typename?: 'EntityPage';
              slug: string;
              logoImage?: Array<{
                __typename?: 'ScaledImage';
                url?: string | null;
              }> | null;
            } | null;
          };
    } | null>;
  } | null;
};

export const GetRecommendationsByTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRecommendationsByType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'after' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'pageType' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ReducedContentPageType' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortField' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ContentPageSortField' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'sortOrder' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ContentSortOrder' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contentPagesNewsSourcesByType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'first' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'after' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pageType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'pageType' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortField' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortField' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sortOrder' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'sortOrder' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasNextPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasPreviousPage' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startCursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endCursor' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cursor' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'globalId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'title' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'interactions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'isFollowed' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entityPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'slug' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logoImage' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: {
                                          kind: 'Name',
                                          value: 'dimensions',
                                        },
                                        value: {
                                          kind: 'ObjectValue',
                                          fields: [
                                            {
                                              kind: 'ObjectField',
                                              name: {
                                                kind: 'Name',
                                                value: 'width',
                                              },
                                              value: {
                                                kind: 'IntValue',
                                                value: '128',
                                              },
                                            },
                                            {
                                              kind: 'ObjectField',
                                              name: {
                                                kind: 'Name',
                                                value: 'height',
                                              },
                                              value: {
                                                kind: 'IntValue',
                                                value: '128',
                                              },
                                            },
                                            {
                                              kind: 'ObjectField',
                                              name: {
                                                kind: 'Name',
                                                value: 'reference',
                                              },
                                              value: {
                                                kind: 'StringValue',
                                                value: 'logo',
                                                block: false,
                                              },
                                            },
                                          ],
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'url' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: { kind: 'Name', value: 'ContentPage' },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'logoImage' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'square128',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'ContentInsiderPage',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'xingId' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'profileImage',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'size',
                                              },
                                              value: {
                                                kind: 'EnumValue',
                                                value: 'SQUARE_128',
                                              },
                                            },
                                          ],
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'url',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetRecommendationsByTypeQuery,
  GetRecommendationsByTypeQueryVariables
>;
